import { formatToCurrency } from "shared/utils";
import { FeeRefundedActivity } from "../types";

export const FeeRefunded = ({
  activity
}: {
  activity: FeeRefundedActivity;
}) => {
  const userRefunded =
    activity.details.refunded_to_full_name ?? activity.details.refunded_to;
  return (
    <div>
      <p>
        <span className="font-bold">
          {activity.details.fee_description} was refunded
        </span>
        {userRefunded && ` to ${userRefunded}`}
      </p>
      <p className="text-sm text-content-400 mt-2">
        Refunded amount:{" "}
        {`${formatToCurrency(activity.details.refunded_amount, { minimumFractionDigits: 2 })} of ${formatToCurrency(activity.details.original_amount, { minimumFractionDigits: 2 })}`}
      </p>
    </div>
  );
};
